import { DataGridPremium, GridToolbar } from "@mui/x-data-grid-premium";
import dayjs from "dayjs";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CustomPagination } from "../../../components/mui/grids/dataGridCustom/customPagination";
import { muiGridLocales } from "../../../helpers/mui/muiLocales";
import { getRouteUrl } from "../../../helpers/routing/getRouteUrl";
import { ROUTE_PAGE_PROJECT_DETAILS } from "../../projects/routes/routes";
import { REPORTS } from "../locales/namespaces";

export function ProjectGridContainer({ 	data,
										 isLoading,
										 page,
										 pageSize,
										 onFilterModelChange,
										 onPaginationModelChange,
										 onSortModelChange,
										 total,
										 language,
										 dateFormat,
									 isActive}) {
	const { t } = useTranslation(REPORTS);

	const columns = useMemo(() => {
		return [
			{
				field: "Description",
				headerName: t("Description"),
				minWidth: 300,
				flex: 1,
				renderCell: ({ row }) => (
					<Link
						to={getRouteUrl(ROUTE_PAGE_PROJECT_DETAILS, {
							projectId: row.id
						})}
					>
						{row.Description}
					</Link>
				)
			},
			{
				field: "StartDt",
				headerName: t("Start Date"),
				minWidth: 150,
				flex: 1,
				type: 'date',
				align: 'center',
				valueFormatter: (value) =>
					value ? dayjs(value).format(dateFormat) : null,
				valueGetter: (value) => value && new Date(value)
			},
			{
				field: "EndDt",
				headerName: t("End Date"),
				minWidth: 150,
				flex: 1,
				type: 'date',
				align: 'center',
				valueFormatter: (value) =>
					value ? dayjs(value).format(dateFormat) : null,
				valueGetter: (value) => value && new Date(value)
			},
			{
				field: "EstimCost",
				headerName: t("Estim. Cost"),
				minWidth: 120,
				flex: 1,
				type: 'number',
				valueGetter: (value) => Number(value)?.toFixed(2) ? Number(value) : 0.00,
			},
			{
				field: "WorkTm",
				headerName: t("Work Time"),
				minWidth: 120,
				flex: 1,
				type: 'number',
				valueGetter: (value) => value ? Number(value) : 0.00,
				// valueFormatter: (params) => params.value.toFixed(2),
			},
			{
				field: "ExtraWorkTm",
				headerName: t("Extra Work Time"),
				minWidth: 120,
				flex: 1,
				type: 'number',
				valueGetter: (value) => value ? Number(value) : 0.00,
				// valueFormatter: (params) => params.value.toFixed(2),
			},
			{
				field: "WithContibutions",
				headerName: t("With Contibutions"),
				minWidth: 120,
				flex: 1,
				type: 'number',
				valueGetter: (value) => value ? Number(value) : 0.00,
				valueFormatter: (params) => params.value?.toFixed(2),
			},
			{
				field: "WorkCost",
				headerName: t("Work Cost"),
				minWidth: 120,
				flex: 1,
				type: 'number',
				valueGetter: (value) => value ? Number(value) : 0.00,
				valueFormatter: (params) => params.value?.toFixed(2),
			},
			{
				field: "ExtraWorkCost",
				headerName: t("Extra Work Cost"),
				minWidth: 120,
				flex: 1,
				type: 'number',
				valueGetter: (value) => value ? Number(value) : 0.00,
				valueFormatter: (params) => params.value?.toFixed(2),
			},
			// {
			// 	field: "perCost",
			// 	headerName: t("Per Cost"),
			// 	minWidth: 120,
			// 	flex: 1
			// },
		];
	}, [t]);
	
	return (
		<DataGridPremium
			sx={{
				'& .MuiDataGrid-headerFilterRow': {
					background: `linear-gradient(90deg, #e2e7e3 05%, #f6f7f7 95%)`
				},
				'& .MuiFormLabel-root': {
					display: 'none',
				},
			}}
			columns={columns}
			rows={data}
			pagination
			paginationModel={{ page, pageSize }}
			paginationMode="server"
			onPaginationModelChange={onPaginationModelChange}
			rowCount={Number(total)}
			pageSizeOptions={[5, 10, 15, 20, 50, 100]}
			sortingMode="server"
			onSortModelChange={(sortModel) => onSortModelChange(sortModel)}
			filterMode="server"
			onFilterModelChange={onFilterModelChange}
			loading={isLoading}
			initialState={{
				density: 'compact',
				columns: {
					columnVisibilityModel: {
						// ContactName: false,
						// DepartureDate: false,
						// SupplierName: false,
						// AgencyName: false,
						// MediatorName: false,
						// BrokerName: false,
						// CargoDescription: false
					},
				},
			}}
			slots={{
				pagination: CustomPagination,
				headerFilterMenu: null,
			}}
			disableColumnFilter
			headerFilters
			localeText={muiGridLocales(language)}
		/>
	);
}
